import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-settings-client',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less']
})
export class SettingsComponent implements OnInit {

  currentCompany: any = null
  currentCompanyId: any = null
  
  subscription: Subscription;
  constructor(private dataService: DataService) {
    this.subscription = this.dataService.sharedCompanyId$.subscribe(company => {
      this.currentCompanyId = company;
      if (!this.currentCompanyId && localStorage.getItem('currentCompany')) {
        let company = JSON.parse(localStorage.getItem('currentCompany'));

        this.currentCompany = company ? company.name : null
        // this.currentCompanyId = company ? company._id : null
        this.dataService.updateCompany(company.name)
        this.dataService.updateCompanyId(company._id)
      }
    })
    
  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
